import { Controller } from '@hotwired/stimulus'
import { downloadPanel } from '../../services'

export default class extends Controller<HTMLElement> {
  static targets = ['panel']
  static values = { filename: String }

  declare readonly panelTarget: HTMLElement
  declare readonly filenameValue: string

  async download(event: Event): Promise<void> {
    const option = event.currentTarget as HTMLButtonElement | null
    const format = option?.dataset.download

    if (!format) return

    try {
      await downloadPanel(this.panelTarget, format, `${this.filenameValue}.${format}`)
    } catch (error) {
      console.error('[progress-panel--download]', error)
    }
  }
}
